import { FaroDialog } from "@components/common/dialog/faro-dialog";
import { FaroText } from "@faro-lotv/flat-ui";
import { IntegrationDialogProps } from "@custom-types/integrations-types";
import { INTEGRATION_INFO } from "@src/constants/integrations-constants";

/** Shows dialog for disconnecting an integration */
export function IntegrationsDisconnectDialog({
  dialogConfirmCallback,
  dialogCancelCallback,
  integrationId,
}: IntegrationDialogProps): JSX.Element {
  return (
    <FaroDialog
      open={true}
      onConfirm={dialogConfirmCallback}
      onClose={dialogCancelCallback}
      confirmText="Disconnect"
      title="Disconnect account?"
      confirmButtonColor="red"
    >
      <FaroText component="p" variant="bodyM">
        Are you sure you want to disconnect {INTEGRATION_INFO[integrationId].displayName}?
      </FaroText>
      <FaroText component="p" variant="bodyM">
        This action will remove your personal connection and disable its features in
        all associated projects.
      </FaroText>
    </FaroDialog>
  );
}
